const getStyles = () => {
  return {
    // Section
    section: {
      padding: '80px 0',
      background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)'
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 16px',
      '@media (min-width: 640px)': {
        padding: '0 24px'
      }
    },

    // Header
    header: {
      textAlign: 'center',
      marginBottom: '64px',
      animation: 'fadeIn 0.8s ease-out'
    },
    title: {
      fontSize: '2.25rem',
      fontWeight: 'bold',
      color: '#1a202c',
      marginBottom: '16px',
      '@media (min-width: 768px)': {
        fontSize: '3rem'
      }
    },
    subtitle: {
      fontSize: '1.25rem',
      color: '#6b7280',
      maxWidth: '500px',
      margin: '0 auto'
    },

    // Testimonial Card
    testimonialCard: {
      border: '1px solid #e2e8f0',
      borderRadius: '16px',
      backgroundColor: '#ffffff',
      transition: 'all 0.3s ease',
      height: '100%',
      animation: 'fadeInScale 0.8s ease-out',
      '&:hover': {
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
        transform: 'translateY(-8px)'
      }
    },
    cardContent: {
      padding: '32px',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px'
    },

    // Rating Stars
    ratingContainer: {
      display: 'flex',
      gap: '4px',
      marginBottom: '12px'
    },
    starIcon: {
      fontSize: '24px',
      color: '#4f46e5', // accent blue
      fill: '#4f46e5'
    },

    // Content Text
    contentText: {
      fontStyle: 'italic',
      color: '#1a202c',
      lineHeight: 1.6
    },

    // Client Info
    clientBox: {
      borderTop: '1px solid #e2e8f0',
      paddingTop: '16px'
    },
    clientName: {
      fontWeight: 'bold',
      color: '#1a202c'
    },
    clientRole: {
      fontSize: '0.875rem',
      color: '#6b7280'
    },

    // Animations
    '@keyframes fadeIn': {
      '0%': { opacity: 0, transform: 'translateY(20px)' },
      '100%': { opacity: 1, transform: 'translateY(0)' }
    },
    '@keyframes fadeInScale': {
      '0%': { opacity: 0, transform: 'scale(0.95)' },
      '100%': { opacity: 1, transform: 'scale(1)' }
    }
  };
};

export default getStyles;
